import { createRouter, createWebHistory } from 'vue-router'
import home_view from '../views/home_view.vue'
import contact from '../views/contact_view.vue'
import intern from '../views/intern_view.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: home_view
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/about_view.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // mri: 2026-01-24
    // component: () => import(/* webpackChunkName: "contact" */ '../views/contact_view.vue')
    component: contact
  },
  {
    path: '/intern',
    name: 'intern',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // mri: 2026-01-24
    // component: () => import(/* webpackChunkName: "intern" */ '../views/intern_view.vue')
    component: intern
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
